import img_Projet1 from "../assets/imgPortfolio/img_Projet1.png";
import img_Projet2 from "../assets/imgPortfolio/img_Projet2.png";

const dataPortfolio = [
  {
    image: img_Projet2,
    lien: "https://wcs-weather.netlify.app/",
    titre: "WCS-Weather",
    categorie: "ReactJs / Tailwindcss",
    description:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit. Vivamus quis Lorem ipsum dolor sit amet consectetur adipiscing elit. Vivamus quis Lorem ipsum dolor sit amet consectetur adipiscing elit. Vivamus quis",
  },
  {
    image: img_Projet1,
    lien: "https://kvnmrs.github.io/WCS_Projet_1/",
    titre: "NantesAutrement",
    categorie: "HTML/CSS",
    description:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit. Vivamus quis Lorem ipsum dolor sit amet consectetur adipiscing elit. Vivamus quis Lorem ipsum dolor sit amet consectetur adipiscing elit. Vivamus quis",
  },
];

export default dataPortfolio;
